
const TrialResultsContent = () => {
    return (
        <>
            <h4>
                The Breast International Group BIG 02-98 / IBCSG 20-98 clinical trial results
            </h4>
            <p>
                The Breast International Group BIG 02-98 / IBCSG 20-98 trial evaluated the activity of the drug Docetaxel, given either in combination or after treatment with Doxorubicin, followed by the combination of Cyclophosphamide, Methotrexate and Fluorouracil (CMF). The results were presented at the American Society of Clinical Oncology meeting in Atlanta, USA, and published in the Journal of the National Cancer Institute. This study was a major achievement for Breast Cancer Trials, with accrual of 605 women from Australia and New Zealand out of a total international accrual of 2,887. Subsequent trial translational research provided new insights into the immune system and breast cancer.
            </p>
        </>
    );
}

export default TrialResultsContent;